import { render, staticRenderFns } from "./CTAElement.vue?vue&type=template&id=0ee83e72&"
import script from "./CTAElement.vue?vue&type=script&lang=js&"
export * from "./CTAElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports